import { UserRolesAndPermissionsService } from '@account-users/user/services/user-roles-and-permissions.service';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BossStateService } from '@boss/state/boss-state.service';
import { BossItem } from '@boss/state/models';

@Component({
  selector: 'app-apsis-back-office-boss',
  templateUrl: './boss.component.html',
  styleUrls: ['./boss.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BossComponent implements OnInit {
  public readonly bossReports$ = this.bossStateService.selectBossReports();
  public readonly hasOrderManagerRole$ = this.userRolesService
    .hasOrderManagerRole$;

  public readonly currentYear = new Date().getFullYear();
  public readonly currentMonth = new Date().getMonth() + 1;

  constructor(
    private readonly bossStateService: BossStateService,
    private readonly userRolesService: UserRolesAndPermissionsService,
  ) {}

  ngOnInit(): void {
    this.bossStateService.loadReports();
  }

  public trackByBossFn(_: number, { period }: BossItem) {
    return period;
  }

  public refresh(item: BossItem) {
    this.bossStateService.refreshReport(item);
  }

  public download(item: BossItem) {
    this.bossStateService.downloadReport(item);
  }
}
